module.exports = __webpack_public_path__ + "static/media/volume-low.c75a3262.svg";